import { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import { onNativeEvent } from "../../platform/android/nativeEventBus";
import { NATIVE_EVENTS, APP_METHODS } from "../../platform/android/nativeMethods";
import { Native } from "../../platform/android/nativeBridge";
import { FiArrowRight } from "react-icons/fi";
import "./GoToSettingModal.scss";

export default function GoToSettingModal() {
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  useEffect(() => {
    const unsubscribeDenied = onNativeEvent(NATIVE_EVENTS.PERMISSIONS_DENIED, () => {
      // Show custom modal on OS permission deny
      setShowSettingsModal(true);
    });

    const unsubscribePromptSettings = onNativeEvent(
      NATIVE_EVENTS.PROMPT_USER_TO_OPEN_SETTINGS,
      () => {
        // Show custom modal if OS permanently denied permission
        setShowSettingsModal(true);
      }
    );

    const unsubscribeClose = onNativeEvent("CLOSE_SETTINGS_MODAL", () => {
      setShowSettingsModal(false);
    });

    const unsubscribeGranted = onNativeEvent(NATIVE_EVENTS.PERMISSIONS_GRANTED, () => {
      setShowSettingsModal(false);
    });

    return () => {
      unsubscribeDenied();
      unsubscribePromptSettings();
      unsubscribeClose();
      unsubscribeGranted();
    };
  }, []);

  return (
    <Modal
      isOpen={showSettingsModal}
      onClose={() => {}}
      closeOnBackdropClick={false}
      showCloseButton={false}
      title="Permissions"
      isPermissionModal={true}
    >
      <div className="goto-setting-modal-content">
        <p className="goto-setting-modal-text">
          You have denied some of the required permissions. Please allow all permissions to
          continue.
        </p>

        <div className="goto-setting-steps">
          <span className="step-text">Settings</span>
          <FiArrowRight className="step-arrow" />
          <span className="step-text step-highlight">Allow All Permissions</span>
        </div>

        <Button
          onClick={() => {
            Native.send(APP_METHODS.OPEN_APP_SETTINGS);
          }}
        >
          Go to settings &gt;
        </Button>
      </div>
    </Modal>
  );
}
